import { api } from '@/shared/services/baseApiClient';
import { config } from '@/config/config';
import urljoin from 'url-join';
import { UpdateBotFlowsPriorityViewModel } from '@/features/bots/models/request/updateBotFlowsPriorityViewModel';
import { AddBotFlowViewModel } from '@/features/bots/models/addBotFlowViewModel';
import { FlowViewModel } from '@/features/bots/models/designer';
import { UpdateBotFlowViewModel } from '../models/request/updateBotFlowViewModel';
import { FlowListItemViewModel } from '../models/flowListItemViewModel';
import { GetFlowsViewModel } from '@/features/bots/models/request/getFlowsViewModel';
import { ImportBotFlowViewModel } from '../models/request/importBotFlowViewModel';

class FlowsApiService {
  private version = 'v1';

  public getFlows(botId: string): Promise<GetFlowsViewModel> {
    return api.send('GET', urljoin(config().flowsHost, this.version, botId, 'flows'));
  }

  public addFlow(botId: string, request: AddBotFlowViewModel): Promise<FlowListItemViewModel> {
    return api.send<FlowListItemViewModel>(
      'POST',
      urljoin(config().flowsHost, this.version, `${botId}/flows`),
      request,
    );
  }

  public getFlow(botId: string, flowId: string): Promise<FlowViewModel> {
    return api.send('GET', urljoin(config().flowsHost, this.version, `${botId}/flows/${flowId}`));
  }

  public updateFlow(botId: string, flowId: string, request: UpdateBotFlowViewModel): Promise<FlowViewModel> {
    return api.send<FlowViewModel>(
      'PATCH',
      urljoin(config().flowsHost, this.version, `${botId}/flows/${flowId}`),
      request,
    );
  }

  public cloneFlow(botId: string, flowId: string): Promise<FlowListItemViewModel> {
    return api.send('POST', urljoin(config().flowsHost, this.version, `${botId}/flows/${flowId}/clone`));
  }

  public importFlow(botId: string, request: ImportBotFlowViewModel): Promise<FlowListItemViewModel> {
    return api.send('POST', urljoin(config().flowsHost, this.version, `${botId}/flows/import`), request);
  }

  public updateFlows(botId: string, request: UpdateBotFlowsPriorityViewModel): Promise<void> {
    return api.send('POST', urljoin(config().flowsHost, this.version, `${botId}/flows/reorder`), request);
  }

  public deleteFlow(botId: string, flowId: string): Promise<any> {
    return api.send('DELETE', urljoin(config().flowsHost, this.version, `${botId}/flows/${flowId}`));
  }
}

export const flowsApi = new FlowsApiService();
